

function Hero() {
  return (
                <section className="hero__area hero__v2 hero__height" id="#">
                    <div className="container maxw_1410">
                        <div className="row align-items-center flex-row-reverse mt-none-50">
                            <div className="col-lg-7">
                                <div className="hero__imgs mt-50">
                                    <img src="assets/img/hero/img_02.png" alt="" />
                                    <img src="assets/img/hero/img_03.png" alt="" />
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="hero__content mt-50">
                                    {/* <span className="sub__title"><i className="fas fa-star"></i>we access right...</span> */}
                                    <h2 className="title">Empowering Your HR Strategy</h2>
                                    <p>Tailored Solutions for Talent and Organizational Success</p>
                                    <div className="btns mt-25">
                                        <a className="thm_btn" href="#services">Our Services</a>
                                        <a className="thm_btn thm_btn-2" href="https://ttnconsulting.zohorecruit.com/jobs/Careers" target="_blank">Careers</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
  )
}

export default Hero
